var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Directive } from 'angular-ts-decorators';
let AutoFocusDirective = class AutoFocusDirective {
    $timeout;
    // Important for DI being minification-safe
    static $inject = ['$timeout'];
    constructor($timeout) {
        this.$timeout = $timeout;
    }
};
AutoFocusDirective = __decorate([
    Directive({
        selector: 'auto-focus',
        link: function (scope, element, attrs, instance) {
            attrs.$observe('autoFocus', function (newValue) {
                if (newValue === 'true') {
                    instance.$timeout(() => {
                        element.focus();
                    }, scope['timeout'] ?? 0);
                }
            });
        },
        scope: {
            timeout: '=autoFocusTimeout',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.ITimeoutService) === "function" ? _a : Object])
], AutoFocusDirective);
export { AutoFocusDirective };
